import React from "react";
import MarketIndicesDashboardClient from "./MarketIndicesClient";
import type {
  IndexListItem,
  IndicesInsightsConfig,
  ScripInfoData,
} from "./Interface";
import { getFilteredIndicesList } from "../../services/TradingMallService";
import { fetchIndicesScripInfo } from "./indicesinfo";

interface MarketIndicesDashboardProps {
  config?: IndicesInsightsConfig;
}

export const MarketIndicesDashboard: React.FC<
  MarketIndicesDashboardProps
> = async ({ config }) => {
  const indicesList: IndexListItem[] = await getFilteredIndicesList();
  const initialIndices = indicesList.slice(0, 4);
  const initialDataEntries = await Promise.all(
    initialIndices.map(async (index) => {
      const data = await fetchIndicesScripInfo(index.token, index.exchange ?? 0);
      return [index.token, data] as const;
    }),
  );
  const initialDataByToken = Object.fromEntries(initialDataEntries) as Record<
    number,
    ScripInfoData | null
  >;
  const firstIndex = initialIndices[0];
  const initialData: ScripInfoData | null =
    (firstIndex ? initialDataByToken[firstIndex.token] : null) ?? null;

  return (
    <section
      id="indices-insight"
      className="scroll-mt-[var(--bfl-header-height-mobile)] md:scroll-mt-[var(--bfl-header-height-desktop)] px-4 py-3 md:max-w-[864px]"
    >
      <MarketIndicesDashboardClient
        indicesList={indicesList}
        config={config}
        initialIndexSymbol={firstIndex?.symbol ?? ""}
        initialData={initialData}
        initialDataByToken={initialDataByToken}
      />
    </section>
  );
};
